import * as React from 'react';
import {BrowseResultsProps} from './results';
import gql from 'graphql-tag';
import {graphql, InjectedGraphQLProps} from 'react-apollo';
import {Component, deps, inject, observer} from '../../lib/component';
import {style} from 'typestyle';
import {important, viewHeight} from 'csx';
import {centerCenter} from 'csstips';
import {TagTileGrid, TagTileItem} from '../tile-grid';
import {gradientDark} from '../../theme/gradient';
import {TagTile} from '../tag-tile';
import {PaginationInput} from '../../types';

@inject(deps) @observer
class BrowseTagGrid extends Component<Props & InjectedGraphQLProps<Data>> {
  render() {
    const {data, type} = this.props;
    const {handleClickLink} = this.props.controller.ui;
    const {preloadImage} = this.props.controller.image;

    const tiles = data && data.tiles && data.tiles.results
      ? data.tiles.results
      : [];

    return (
      <div className={BrowseTagGrid.styles.container}>
        <TagTileGrid
          tiles={tiles}
          loading={data.loading}
          loadingTiles={12}
          loadingLight={true}
          renderTile={(itemClass: string, tile: TagTileItem, index: number) => (
            <TagTile
              className={itemClass}
              href={BrowseTagGrid.tagPath(type, tile.slug)}
              key={tile.slug + index}
              tag={tile}
              preload={preloadImage}
              onClickLink={handleClickLink}
            />
          )}
        />
      </div>
    )
  }

  static tagPath = (type: Type, slug: string) => {
    const [,part] = type.split('_');
    return `/browse/${part}/${slug}`;
  };

  static styles = {
    container: style({
      background: gradientDark,
    }),
    loading: style({
      ...centerCenter,
      width: important('100%'),
      height: viewHeight(40)
    })
  };
}

type Type
  = 'hookd_genre'
  | 'hookd_theme'
  | 'hookd_mood';

type Props = {
  type: Type,
  pagination: PaginationInput
}

type Item = {
  name: string;
  slug: string;
  images: {
    identity: string;
  }
}

type Data = {
  tiles: {
    results: Array<Item>
  }
}

export default BrowseTagGrid;

export const ConnectedBrowseTagGrid = graphql(gql`
  query (
    $type: String
    $pagination: PaginationInput!
  ) {
    tiles: browseTag(options:{type:TAG, query: $type, pagination: $pagination}) {
      results {
        name
        slug
        images {
          identity
        }
      }
    }
  }
`, {
  options: (variables: BrowseResultsProps) => ({
    variables,
    // fetchPolicy: 'network-only'
  }),
})(BrowseTagGrid);